import { render, staticRenderFns } from "./content-loader.vue?vue&type=template&id=60c08762&"
import script from "./content-loader.vue?vue&type=script&lang=ts&"
export * from "./content-loader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports